var map = {
	"./1.png": 4096,
	"./11.png": 6912,
	"./12.png": 692,
	"./13.png": 9810,
	"./14.png": 8968,
	"./15.png": 6373,
	"./16.png": 7744,
	"./17.png": 6899,
	"./18.png": 924,
	"./19.png": 4059,
	"./2.png": 2716,
	"./4.png": 2759,
	"./8.png": 1870,
	"./9.png": 9119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6845;